const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:4001/api";
const ASSET_BASE_URL = API_BASE_URL.replace(/\/?api\/?$/, "").replace(/\/$/, "");

const isAbsoluteUrl = (url: string) => /^https?:\/\//i.test(url);

export const resolveMediaUrl = (path?: string | null): string | null => {
    if (!path) {
        return null;
    }

    const trimmed = path.trim();
    if (!trimmed) {
        return null;
    }

    if (isAbsoluteUrl(trimmed)) {
        return trimmed;
    }

    if (trimmed.startsWith("/")) {
        return `${ASSET_BASE_URL}${trimmed}`;
    }

    return `${ASSET_BASE_URL}/${trimmed.replace(/^\/+/, "")}`;
};
